import styles from 'css/src/components/common/ui/Avatar.module.scss';

import React from 'react';
import classnames from 'classnames';

type Props = {
    image?: string | null;
    imageCustomClass?: string;
    textCustomClass?: string;
    text?: string;
    size?: 'xlarge' | 'large' | 'normal' | 'small';
    topLeftBadge?: React.ReactNode;
    onClick?: VoidFunction;
    className?: string;
    shouldHighlight?: boolean;
    ref?: React.Ref<HTMLDivElement>;
};

/**
 * Shows user's profile image.
 */
const Avatar = React.memo(function Avatar({
    image = '',
    imageCustomClass = '',
    text = 'L5',
    textCustomClass = '',
    size = 'normal',
    topLeftBadge = null,
    onClick,
    className = '',
    shouldHighlight = false,
    ref,
}: Props) {
    const avatarNode = image ? (
        <img
            className={classnames(styles['avatar-img'], imageCustomClass)}
            src={image}
            alt="avatar"
            draggable={false}
        />
    ) : (
        <div
            className={classnames(
                styles['avatar-text'],
                'text-uppercase',
                styles[size],
                textCustomClass,
            )}
        >
            {text.substring(0, 3)}
        </div>
    );
    return (
        <div
            ref={ref}
            className={classnames(styles['avatar-wrapper'], className, styles[size], {
                [styles['with-topLeftBadge']]: !!topLeftBadge,
                [styles['avatar-selected']]: shouldHighlight,
            })}
            onClick={onClick}
        >
            {!!topLeftBadge && <div className={styles['topLeftBadge']}>{topLeftBadge}</div>}
            {avatarNode}
        </div>
    );
});

export default Avatar;
